// extracted by mini-css-extract-plugin
export default {"rating":"xA-z","numberOfStars":"yA-z","count":"zA-z","barGraphSpacing":"AA-z","barGraph":"BA-z"};